import { render, staticRenderFns } from "./ApplianceModelCreate.vue?vue&type=template&id=69671afb"
import script from "./ApplianceModelCreate.vue?vue&type=script&lang=js"
export * from "./ApplianceModelCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports